module.exports = __webpack_public_path__ + "static/media/movie.ca38a121.svg";